module.exports = __webpack_public_path__ + "static/img/tx_ywx.fd1fdb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/team/tx_ywx.png
// module id = QhAi
// module chunks = 0